document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-aldevor-product]').forEach(product => {
    const main = product.querySelector('[data-product-main] img');
    const thumbnails = product.querySelector('[data-product-thumbnails]');
    const select = product.querySelector('[data-variant-select]');
    const price = product.querySelector('[data-product-price]');
    const add = product.querySelector('[data-product-add]');
    const variantData = product.parentElement.querySelector('[data-product-variants]');

    if (!main) return;

    const getCurrency = () =>
      document.querySelector('meta[property="og:price:currency"]')?.content || 'USD';

    const formatPrice = (amount) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: getCurrency()
      }).format(amount / 100);

    const showImage = (url, alt) => {
      if (!url) return;
      main.src = url;
      main.alt = alt || main.alt;
      if (thumbnails) {
        thumbnails.querySelectorAll('button').forEach(item => {
          const active = item.dataset.imageUrl === url;
          item.classList.toggle('is-active', active);
          if (active) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      }
    };

    if (thumbnails) {
      thumbnails.addEventListener('click', event => {
        const button = event.target.closest('[data-image-url]');
        if (button) showImage(button.dataset.imageUrl, button.dataset.imageAlt);
      });
    }

    if (!select || !variantData) return;

    let variants = [];
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      return;
    }

    const applyVariant = (variant) => {
      if (!variant) return;
      if (variant.featured_image) showImage(variant.featured_image.src, variant.featured_image.alt);
      if (price) price.innerHTML = variant.price ? formatPrice(variant.price) : price.innerHTML;
      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available
          ? 'Add to bag — ' + formatPrice(variant.price)
          : 'Sold out';
      }
    };

    select.addEventListener('change', () => {
      const variant = variants.find(item => String(item.id) === String(select.value));
      applyVariant(variant);
    });

    const urlParams = new URLSearchParams(window.location.search);
    const urlVariantId = urlParams.get('variant');
    if (urlVariantId) {
      const matchedVariant = variants.find(item => String(item.id) === String(urlVariantId));
      if (matchedVariant) {
        select.value = urlVariantId;
        applyVariant(matchedVariant);
      }
    }
  });
});

